import script from "./SubscribeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeSection.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeSection.vue?vue&type=style&index=0&id=2a2e59fc&lang=scss"

const __exports__ = script;

export default __exports__